module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook-w540.1aa873a7.jpg";